export function downloadText (fileName, content, type = 'text/csv;charset=utf-8') {
  const blob = new Blob(['\ufeff', content], { type })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  URL.revokeObjectURL(url)
}

export function csvText (columns, rows) {
  const escape = value => `"${String(value === null || value === undefined ? '' : value).replace(/"/g, '""')}"`
  return [columns.map(column => escape(column.title)).join(','), ...rows.map(row => columns.map(column => escape(row[column.key])).join(','))].join('\n')
}

export function downloadCsv (fileName, columns, rows) {
  const normalizedName = fileName.toLowerCase().endsWith('.csv') ? fileName : `${fileName}.csv`
  downloadText(normalizedName, csvText(columns, rows))
}
